import { CostCenter, CostCenter2, Employee, RightEnum, TripFolder } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import EmployeeLink from "Components/employeeLink"
import FolderStatusTag from "Components/folderStatusDraft"
import { ApprovalProcessService, AuthzService } from "Shared/services"
import { getNextExpenseEmbeddedApprover } from "Shared/utils/approvalProcess.utils"
import { isFolderExpense } from "Shared/utils/expense.utils"

import { useLoggedInEmployeeProfile } from "../../../../../shared/hooks/user.hooks"
import { formatExpenseDate } from "../../../../../shared/utils/date.utils"
import { CostCenter2Field } from "./costCenter2.field"
import { ExpenseAccountField } from "./expenseAccount.field"
import { WorkflowField } from "./workflow.field"

interface FolderTabProps {
    expense: TripFolder
    requestedBy: Employee
    costCenter?: CostCenter
    costCenter2?: CostCenter2
    isExpenseUpdating?: boolean
}

export const FolderTabContent = ({ expense, requestedBy, costCenter, costCenter2, isExpenseUpdating }: FolderTabProps) => {
    const { t } = useTranslation()

    const loggedInUser = useLoggedInEmployeeProfile()

    const nextApprover = ApprovalProcessService.getNextApprover(expense.approvalProcesses)
    const nextExpenseEmbeddedApprover = getNextExpenseEmbeddedApprover(expense.approvalProcesses)
    const isCostCenterApprover = AuthzService.isRightGrantedForLoggedInUser(RightEnum.CC1__ALL__OWNER) && loggedInUser.id === costCenter?.responsibleUser

    if (!isFolderExpense(expense)) {
        return <></>
    }

    return (
        <ul className="description-list pb-10 overflow-auto">
            <li>
                <span className="title">{t("label:status")}</span>
                <span className="text">
                    <FolderStatusTag folder={expense as TripFolder} />
                </span>
            </li>
            <li>
                <span className="title">{t("label:folder.trip_start_date")}</span>
                <span className="text">{formatExpenseDate(expense.tripDate)}</span>
            </li>
            <li>
                <span className="title">{t("label:requested_by")}</span>
                <span className="text truncate max-w-250">
                    <EmployeeLink employee={requestedBy} expenseExtendedRefUser={expense.requestedBy} />
                </span>
            </li>
            {nextApprover && (
                <li>
                    <span className="title">{t("label:next_approver")}</span>
                    <span className="text truncate max-w-250">
                        <EmployeeLink employee={nextApprover} expenseExtendedRefUser={nextExpenseEmbeddedApprover} />
                    </span>
                </li>
            )}
            <WorkflowField expense={expense} />
            <li>
                <span className="title">{t("label:cost_center")}</span>
                <span>
                    {AuthzService.isRightGrantedForLoggedInUser(RightEnum.CC1__ALL__READ) || isCostCenterApprover ? (
                        <Link to={`/costCenters/${costCenter?._id}`}>{costCenter?.name}</Link>
                    ) : (
                        costCenter?.name
                    )}
                </span>
            </li>

            <CostCenter2Field expense={expense} costCenter2={costCenter2} />
            <ExpenseAccountField expense={expense} isInputDisabled={true} isReadOnly={true} isLoading={isExpenseUpdating} />
            <li>
                <span className="title">{t("label:folder.submitted_on")}</span>
                <span className="text">{formatExpenseDate(expense.createdAt)}</span>
            </li>
        </ul>
    )
}
